import { makeStyles } from '@/styles/theme/tss-react';

interface Props {
  aspectRatio: string | null;
}

const useStyles = makeStyles<Props>({
  name: 'VimeoVideo',
})(({ typography, brandColors, aspectRatio }, props) => ({
  container: {
    position: 'relative',
    aspectRatio: props.aspectRatio || aspectRatio['16/9'],
    /* Required because of existing bug with react player library
     * https://github.com/CookPete/react-player/issues/810
     */
    '& iframe': {
      width: '100%',
      height: '100%',
    },
  },
  absoluteFill: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
  },
  thumbnail: {
    zIndex: 1,
    objectFit: 'cover',
  },
  hidden: {
    visibility: 'hidden',
  },
  rounded: {
    '& > div': {
      borderRadius: typography.pxToRem(16),
    },
    // Ensure the iframe wrapper div inside respects border-radius
    '& > div > div': {
      borderRadius: typography.pxToRem(16),
      overflow: 'hidden',
    },
  },
  playButtonOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    '&:focus-visible': {
      outline: `3px solid ${brandColors.chargeBlue}`,
      outlineOffset: -3,
    },
  },
  playIcon: {
    width: typography.pxToRem(80),
    height: typography.pxToRem(80),
    padding: typography.pxToRem(20),
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: brandColors.white,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
  },
}));

export default useStyles;
